"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yesNoChoices = exports.isYesNoIcon = void 0;
const types_1 = require("@smartsuite/types");
const texts_1 = require("../../texts");
const intl_1 = require("../../locale/intl");
const isYesNoIcon = (displayFormat) => types_1.yesNoIcons.includes(displayFormat);
exports.isYesNoIcon = isYesNoIcon;
/** Choices for a select field migrated from a yes/no field. */
const yesNoChoices = (fromField) => [
    {
        value: types_1.yesValue,
        label: (0, intl_1.$t)(texts_1.yesNoFieldText.yes),
        value_color: fromField.params.color,
        value_help_text: "",
        value_order: 0,
    },
    {
        value: types_1.noValue,
        label: (0, intl_1.$t)(texts_1.yesNoFieldText.no),
        value_color: types_1.yesNoInactiveColor,
        value_order: 1,
    },
];
exports.yesNoChoices = yesNoChoices;
